module.exports = __webpack_public_path__ + "img/ug.f67bc975.svg";